import { render, staticRenderFns } from "./feeConfigList.vue?vue&type=template&id=919b28fa&"
import script from "./feeConfigList.vue?vue&type=script&lang=js&"
export * from "./feeConfigList.vue?vue&type=script&lang=js&"
import style0 from "./feeConfigList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports